import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React from "react";

export const ClearSelection = ({ onClick, disabled = false }) => {
  return (
    <Button
      type="text"
      shape="circle"
      icon={<CloseOutlined />}
      size="small"
      aria-label="clear"
      style={{
        border: "1px solid #d9d9d9",
        background: "#fff",
      }}
      disabled={disabled}
      onClick={onClick}
    />
  );
};
